import { render, staticRenderFns } from "./SupplierVehicleVerification.vue?vue&type=template&id=3a65270e&scoped=true&"
import script from "./SupplierVehicleVerification.vue?vue&type=script&lang=js&"
export * from "./SupplierVehicleVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65270e",
  null
  
)

export default component.exports